// Dependencies
import { Box, Grid, Typography } from "@mui/material";
import React, { useCallback, useRef, useState } from "react";
import { trackEvent } from "src/Amplitude";

// Styles
import { CryptoNewsPageStyles } from "./styles/CryptoNewsPageStyles";

// Components
import ExternalLinkWarning from "../core/ExternalLinkWarning";

interface CryptoNewsProps {
  source: string;
  time: string;
  title: string;
  imageURL: string;
  urlReference: string;
}
export default function CryptoNewsPage({
  source,
  time,
  title,
  imageURL,
  urlReference,
}: CryptoNewsProps) {
  const classes = CryptoNewsPageStyles();

  //Warning Modal Const
  const [externalWarning, setExternalWarning] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const dragStartPos = useRef({ x: 0, y: 0 });

  const handleMouseEvents = useCallback(
    (e: React.MouseEvent) => {
      switch (e.type) {
        case "mousedown":
          setIsDragging(false);
          dragStartPos.current = { x: e.clientX, y: e.clientY };
          break;
        case "mousemove":
          if (
            Math.abs(dragStartPos.current.x - e.clientX) > 5 ||
            Math.abs(dragStartPos.current.y - e.clientY) > 5
          ) {
            setIsDragging(true);
          }
          break;
        case "mouseup":
          if (!isDragging) {
            handleExternalNavigation(urlReference);
            trackEvent("Select_Crypto_News", { event: "Read_More" }, "CryptoNewsPage");
          }
          setIsDragging(false);
          break;
        default:
          break;
      }
    },
    [isDragging, urlReference],
  );

  // TASK: Ask why this is returning
  const setUserSelectionCallBack = (permission: string) => {
    if (permission === "Confirm")
      return (
        window.open(selectedUrl, "_blank") &&
        trackEvent("Select_Crypto_News", {
          event: "Read_More",
          action: "External_Link_Confirm",
        })
      );
  };

  //External Navigation Handler
  const handleExternalNavigation = (link: string) => {
    setExternalWarning(true);
    setSelectedUrl(link);
  };

  function htmlDecode(input: any) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  function timeSince(date: number) {
    var seconds = Math.floor((Date.now() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
      return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      if (Math.floor(interval) === 1) {
        return Math.floor(interval) + " month";
      } else {
        return Math.floor(interval) + " months";
      }
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

  return (
    <Grid container spacing={2} mb={4} style={{ paddingRight: "10px" }}>
      <ExternalLinkWarning
        option={externalWarning}
        setExternalWarning={setExternalWarning}
        handleSelection={setUserSelectionCallBack}
        selectedUrl={urlReference}
      />
      <Grid item xs={12} key={0}>
        <Box
          style={{ cursor: "pointer", userSelect: "none" }}
          onMouseDown={handleMouseEvents}
          onMouseMove={handleMouseEvents}
          onMouseUp={handleMouseEvents}>
          <div key={3} className={classes.container}>
            <img
              src={imageURL}
              width={"100%"}
              height={"200px"}
              style={{ borderRadius: "10px 10px 0px 0" }}
              alt="news icon"
              onDragStart={(e) => e.preventDefault()}
            />
            <Grid container spacing={2} p={3}>
              <Grid item xs={6}>
                <Typography className={classes.titleLeft}>{source}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.titleRight}>
                  {timeSince(parseInt(time))} ago
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {title.length > 200 ? (
                  <Typography className={classes.textContent}>{htmlDecode(title)}</Typography>
                ) : (
                  <>
                    <Typography className={classes.textContent}>
                      {htmlDecode(title.substring(0, 60))}
                      {"... "}
                    </Typography>
                    <Typography className={classes.readMore}>Read More</Typography>
                  </>
                )}
              </Grid>
            </Grid>
          </div>
        </Box>
      </Grid>
    </Grid>
  );
}
